import React from 'react'
import Div from '../Div'
import ContactInfoWidget from '../Widget/ContactInfoWidget'
import MenuWidget from '../Widget/MenuWidget'
import SocialWidget from '../Widget/SocialWidget'
import TextWidget from '../Widget/TextWidget'
import './footer.scss'

export default function Footer({copyrightText, logoSrc, logoAlt, text}) {
  const copyrightLinks = [
    {
      title: 'Terms of Use',
      href: '/'
    },
    {
      title: 'Privacy Policy',
      href: '/privacy-policy'
    }
  ]
  
  const serviceMenu = [
    {
      title: 'Bespoke Website and App Development',
      href: '/service#bespoke-website-and-app-development'
    },
    {
      title: 'Strategic Consulting for Digital Transformation',
      href: '/service#strategic-consulting-for-digital-transformation'
    },
    {
      title: 'Voice Search Optimization',
      href: '/service#voice-search-optimization'
    },
    {
      title: 'Creative Design That Resonates',
      href: '/service#creative-design-that-resonates'
    },
  ]

  return (
    <footer className="cs-fooer">
      <Div className="cs-fooer_main">
        <Div className="container">
          <Div className="row">
            <Div className="col-lg-4 col-sm-6">
              <Div className="cs-footer_item">
                <TextWidget 
                  logoSrc='/images/logo.png' 
                  logoAlt='Logo'
                  text ='At RLAB Group, we’re fostering synergy and creating diverse, inclusive teams for all of our departments and subsidiaries to help us better serve our clients, partners, staff, share-and-stakeholders globally; diversity, equity, and inclusion are among our core principles, we’re learning and iterating daily, personally and professionally, and we resolve to use diversity practices wherever we do business, which underpins our success. Go on, be yourself.'
                />
                <SocialWidget/>
              </Div>
            </Div>
            <Div className="col-lg-4 col-sm-6">
              <Div className="cs-footer_item">
                <MenuWidget menuItems={serviceMenu} menuHeading='Services'/>
              </Div>
            </Div>
            <Div className="col-lg-4 col-sm-6">
              <Div className="cs-footer_item">
                <ContactInfoWidget title='Contact Us'/>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Div className="container">
        <Div className="cs-bottom_footer">
          <Div className="cs-bottom_footer_left">
            <Div className="cs-copyright">Copyright © 2025 RLAB Group</Div>
          </Div>
          <Div className="cs-bottom_footer_right">
            <MenuWidget menuItems={copyrightLinks} variant=' cs-style2'/>
          </Div>
        </Div>
      </Div>
    </footer>
  )
}
